import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute, Params } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";

import { AbstractUserComponent } from "./user.component";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";
import { EntityBase } from "../../entity/EntityBase";
import { AccountSelectData } from "../../obj/AccountSelectData";
import { User } from "../../entity/User";
import { Account } from "../../entity/Account";
import { Utility } from "../../entity/Utility";
import { LoadZone } from "../../entity/LoadZone";
import { RateClass } from "../../entity/RateClass";

@Component({
    template: "",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export abstract class AbstractBuyerComponent extends AbstractUserComponent {
    constructor(
        router: Router,
        route: ActivatedRoute,
        dialog: MatDialog,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService
    ) {
        super(router, route, dialog, analyticsService, generalService, authService);
        this.initPromises.push(this.reloadUser()
            .then(u => {
                if (u!=null && u.isSupplier) {
                    this.authService.logout();
                    this.router.navigate(["/seller/home"]);
                }
            }));
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    protected generateAccountsSelect(data: any[], getAccountFunc: (x: any) => Account): AccountSelectData[] {
        let accountsSelector: AccountSelectData[] = [];
        let acs = [];
        for (let i = 0; i < data.length; i++) {
            acs.push(getAccountFunc(data[i]));
        }
        let utilities: Utility[] = this._getUtilities(acs);
        let loadZones: LoadZone[] = this._getLoadZones(acs);
        let rateClasses: RateClass[] = this._getRateClasses(acs);
        for (let w = 0; w < utilities.length; w++) {
            let utility = utilities[w];
            for (let x = 0; x < loadZones.length; x++) {
                for (let y = 0; y < rateClasses.length; y++) {
                    let first = true;
                    for (let z = 0; z < data.length; z++) {
                        if (getAccountFunc(data[z]).utility != null && getAccountFunc(data[z]).loadZone != null && getAccountFunc(data[z]).rateClass != null) {
                            if ((getAccountFunc(data[z]).utility!.id == utilities[w].id) &&
                                (getAccountFunc(data[z]).loadZone!.id == loadZones[x].id) &&
                                (getAccountFunc(data[z]).rateClass!.id == rateClasses[y].id)) {
                                accountsSelector.push({
                                    group: (first) ? (utility.name + " > " + loadZones[x].name + " > " + rateClasses[y].name) : "",
                                    id: getAccountFunc(data[z]).id,
                                    name: Account.accountIdent(getAccountFunc(data[z])),
                                    text: Account.accountIdent(getAccountFunc(data[z])),
                                    groupIdent: utility.id + ":" + loadZones[x].id + ":" + rateClasses[y].id,
                                    isDisabled: false
                                });
                                first = false;
                            }
                        }
                    }
                }
            }
        }

        return accountsSelector;
    }

    protected _getUtilities(accounts: Account[]): Utility[] {
        let utilities: Utility[] = [];
        for (let s = 0; s < accounts.length; s++) {
            if (accounts[s].utility != null && !EntityBase.includes(utilities, accounts[s].utility)) {
                utilities.push(accounts[s].utility!);
            }
        }
        utilities.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
        return utilities;
    }

    protected _getLoadZones(accounts: (Account|null)[]): LoadZone[] {
        let loadZones: LoadZone[] = [];
        for (let s = 0; s < accounts.length; s++) {
            if (accounts[s]!=null && accounts[s]!.loadZone != null && !EntityBase.includes(loadZones, accounts[s]!.loadZone)) {
                loadZones.push(<LoadZone>accounts[s]!.loadZone);
            }
        }
        loadZones.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
        return loadZones;
    }

    protected _getRateClasses(accounts: (Account|null)[]): RateClass[] {
        let rateClasses: RateClass[] = [];
        for (let i = 0; i < accounts.length; i++) {
            if (accounts[i]!=null && accounts[i]!.rateClass != null && !EntityBase.includes(rateClasses, accounts[i]!.rateClass)) {
                rateClasses.push(<RateClass>accounts[i]!.rateClass);
            }
        }
        rateClasses.sort((a, b) => (a.name! > b.name!) ? 1 : ((b.name! > a.name!) ? -1 : 0));
        return rateClasses;
    }

}